<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('report_out_of_stock') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="print"><i class="fa fa-print"></i> {{$t('print')}}</button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('vendor')}}</label>
                                <div>
                                    <VendorSelector :place="$t('all')" :is-all="true" @select="venSelected"></VendorSelector>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-striped table-sm no-bor">
                        <thead>
                        <tr>
                            <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                            <th>{{ $t('barcode') }}</th>
                            <th>{{ $t('name') }}</th>
                            <th>{{ $t('vendor') }}</th>
                            <th class="text-right">{{ $t('qty_alert') }}</th>
                            <th class="text-right">{{ $t('ending_stock') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(ret, index) in list" :key="index">
                            <td class="text-center">{{index+1}}</td>
                            <td>{{ ret.Num }}</td>
                            <td>{{ ret.Name }}</td>
                            <td>{{ ret.VendorName }}</td>
                            <td class="text-right">{{ ret.AlertQty }}</td>
                            <td class="text-right">{{$number(ret.EndingQty, '0,0.[00]')}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{list.length}}</span>
                </div>
            </div>
        </div>
    </div>
</template>s
<script>
    import { VendorSelector } from '../Vendors';
    export default {
        components: { VendorSelector },
        data: function(){
            return {
                query:{
                    VendorId: '',
                    Page: 1,
                    Total: 0,
                    Limit: 25
                },
                list: []
            }
        },
        created: function(){
            this.toList();
        },
        methods: {
            toList(){
                let loading = this.$loading.show();
                this.$api().post('report/item/outofstock', this.query).then(res => {
                    if(this.$isValid(res)){
                        this.list = res.data.Json.OutOfStock;
                    }
                }).finally(function() { loading.hide(); });
            },
            print() {
                let link = '/print/outofstock?';
                if(this.query.VendorId != '') link = link + 'vendor=' + this.query.VendorId;
                window.open(link, '_blank');
            },
            venSelected(e){
                if(e == null) this.query.VendorId = '';
                else this.query.VendorId = e.Id;
                this.toList();
            }
        }
    }
</script>
